import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";
import { api, errText } from "../../lib/api";
import { fontStyle } from "../../lib/googleFonts";

// One-tap font pairs shared by all admins
export function FontPresets({ slide, set }) {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/hero-font-presets").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const apply = (p) => { set("title_font", p.title_font); set("text_font", p.text_font); toast.success(`Applied “${p.name}” — save to keep it`); };
  const save = async () => {
    const name = window.prompt("Name this font pair (e.g. Playful)")?.trim();
    if (!name) return;
    try { await api.post("/admin/hero-font-presets", { name, title_font: slide.title_font || "", text_font: slide.text_font || "" }); toast.success(`Saved “${name}”`); load(); }
    catch (e) { toast.error(errText(e)); }
  };
  const remove = async (p) => {
    if (!window.confirm(`Delete the “${p.name}” font pair for all admins?`)) return;
    try { await api.delete(`/admin/hero-font-presets/${p.id}`); load(); } catch (e) { toast.error(errText(e)); }
  };
  const active = (p) => (slide.title_font || "") === p.title_font && (slide.text_font || "") === p.text_font;
  return (
    <div className="mb-3" data-testid="hero-font-presets">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-semibold text-slate-600">Font pairs <span className="font-normal text-slate-400">(shared with all admins)</span></span>
        {(slide.title_font || slide.text_font) && (
          <button type="button" onClick={save} className="text-[11px] font-semibold text-[#F5551E] hover:underline flex items-center gap-0.5" data-testid="hero-font-preset-save"><Plus size={12} /> Save this pair</button>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {items.map((p) => (
          <span key={p.id} className={`group inline-flex items-center rounded-full border transition-colors ${active(p) ? "border-[#F5551E] bg-orange-50" : "border-slate-200 hover:border-slate-300"}`} data-testid={`hero-font-preset-${p.id}`}>
            <button type="button" onClick={() => apply(p)} className="pl-3 pr-1.5 h-8 text-left" title={`${p.title_font || "Default"} + ${p.text_font || "Default"}`} data-testid={`hero-font-preset-apply-${p.id}`}>
              <span className="text-sm font-bold text-[#12234A]" style={fontStyle(p.title_font)}>{p.name}</span>
              <span className="text-[10px] text-slate-400 ml-1.5" style={fontStyle(p.text_font)}>{p.text_font || "default"}</span>
            </button>
            <button type="button" onClick={() => remove(p)} aria-label={`Delete ${p.name}`} className="pr-2 text-slate-300 hover:text-red-600" data-testid={`hero-font-preset-delete-${p.id}`}><X size={12} /></button>
          </span>
        ))}
        {!items.length && <span className="text-[11px] text-slate-400">No font pairs yet — pick fonts below, then save them here.</span>}
      </div>
    </div>
  );
}
